import { titleCase } from "change-case-all";
import { useNavigate } from "react-router-dom";

import pages from "../../../constants/pages";
import { DataTable } from "../../../components";
import convertDate from "../../../utils/convertDate";

export default function Table({ resources }) {
  const navigate = useNavigate();

  const options = {
    onRowClick: (_, { dataIndex }) =>
      navigate(pages.resourceDetailsPage.route + resources[dataIndex]._id),
  };

  return <DataTable columns={columns} data={resources} options={options} />;
}

const columns = [
  {
    name: "resource_name",
    label: "Resource Name",
    options: {
      customBodyRender: (value) => {
        return value ? value : "Not Available";
      },
    },
  },
  {
    name: "is_token_generated",
    label: "Token Generated",
    options: {
      customBodyRender: (value) => {
        return value ? "Generated" : "Not Generated";
      },
    },
  },

  {
    name: "created_at",
    label: "Created At",
    options: {
      customBodyRender: (value) => {
        return value ? convertDate(value) : "Not Available";
      },
    },
  },
];
